import React from "react";
import Role from "../../inc/Role";
import toast, { Toaster } from 'react-hot-toast';

import {Config} from '../../Config'
import { Modal, Button } from 'react-bootstrap/esm/index';
import {confirmAlert} from "react-confirm-alert";
import moment from "moment-timezone";
import * as Utils from "../../inc/Utils";

export default function ModalShortIO(props) {
    const roles = new Role();
    let userId = roles.loginUserId;

    let [isLoading, setLoading] = React.useState(false);
    let [shortio, setShortio] = React.useState(null);
    let [charLen, setCharLen] = React.useState(0);
    let [editType, setEditType] = React.useState(1);

    let refNewSlug = React.useRef();
    let refOriginalUrl = React.useRef();
    let refOriginalParams = React.useRef();

    React.useEffect(() => {
        (async function() {
            try {
                const res = await Utils.getShortio();
                setShortio(res);
                refOriginalUrl.current.value = props.data.url;
                let param = '';
                if(props.data.params) {
                    param = props.data.params;
                }
                else if(props.data.paramsUTM) {
                    param = props.data.paramsUTM;
                }
                refOriginalParams.current.value = param;
                refNewSlug.current.value = props.data.shortIO;
                setCharLen(props.data.shortIO.length);
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    const onUpdateShortIO = () => {

        if(editType === 1) {
            onUpdateShortURL();
        }
        else if(editType === 2) {
            onUpdateDestinationURL();
        }
    };

    const onUpdateShortURL = () => {
        let newSlug = refNewSlug.current.value;
        if(!newSlug) {
            toast.error("กรุณาระบุ Link Slug");
            refNewSlug.current.focus();
        }
        else if(newSlug === props.data.shortIO) {
            toast.error("Link Slug ต้องไม่เหมือนปัจจุบัน");
            refNewSlug.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการอัพเดตข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            const body = {
                                updatedBy: userId,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                utmGenerateId: props.data.id,
                                generateTypeUTM: props.data.generateTypeUTM ?? null,
                                originalPath: props.data.shortIO.toString().trim(),
                                newPath: newSlug.toString().trim()
                            };
                            fetch(Config.url.API_URL +'/api/shortio/updateShortUrl', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(async response => {
                                setLoading(false);
                                if(response.ok) {
                                    props.handleModalFormUpdate(true);
                                    props.handleModalClose();
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("อัพเดตข้อมูลเรียบร้อย");
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onUpdateDestinationURL = () => {
        let originalUrl = refOriginalUrl.current.value;
        let originalParams = refOriginalParams.current.value;
        if(!originalUrl) {
            toast.error("กรุณาระบุ Original URL");
            refOriginalUrl.current.focus();
        }
        else if(!originalParams) {
            toast.error("กรุณาระบุ Original Params");
            refOriginalParams.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการอัพเดตข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            const body = {
                                updatedBy: userId,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                utmGenerateId: props.data.id,
                                generateTypeUTM: props.data.generateTypeUTM ?? null,
                                originalURL: originalUrl.toString().trim(),
                                originalParams: originalParams.toString().trim(),
                                originalPath: props.data.shortIO.toString().trim()
                            };
                            fetch(Config.url.API_URL +'/api/shortio/updateDestinationUrl', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(async response => {
                                setLoading(false);
                                if(response.ok) {
                                    props.handleModalFormUpdate(true);
                                    props.handleModalClose();
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("อัพเดตข้อมูลเรียบร้อย");
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeOriginalURL = () => {
        if(refOriginalUrl.current.value !== '') {
            refOriginalUrl.current.value = refOriginalUrl.current.value.toString().trim().replace(' ', '');
        }
    };

    const onChangeOriginalParams = () => {
        if(refOriginalParams.current.value !== '') {
            refOriginalParams.current.value = refOriginalParams.current.value.toString().trim().replace(' ', '');
        }
    };

    const onChangeSlug = () => {
        if(refNewSlug.current.value !== '') {
            refNewSlug.current.value = refNewSlug.current.value.toString().trim().replace(' ', '');
            setCharLen(refNewSlug.current.value.length);
        }
    };

    const onChangeEditType = (typeId) => {
        setEditType(typeId);
    };

    return (
        <>
            <Modal show={true} onHide={props.handleModalClose}>
                <Modal.Header>
                    <Modal.Title>แก้ไข Short.io Link</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="urlType"
                                       id="urlType1" checked={editType===1} onChange={e => onChangeEditType(1)} />
                                <label className="form-check-label" htmlFor="urlType1">
                                    Short URL
                                </label>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="urlType"
                                       id="urlType2" checked={editType===2} onChange={e => onChangeEditType(2)} />
                                <label className="form-check-label" htmlFor="urlType2">
                                    Destination URL
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-1">
                        <div className={"col-12 mt-3 " + (editType===2 ? '':'d-none')}>
                            <span className="d-block fw-bold">Destination URL</span>
                            <textarea className="form-control" rows={3} ref={refOriginalUrl} onKeyUp={onChangeOriginalURL}></textarea>
                        </div>
                        <div className={"col-12 mt-3 " + (editType===2 ? '':'d-none')}>
                            <span className="d-block fw-bold">Params</span>
                            <textarea className="form-control" rows={3} ref={refOriginalParams} onKeyUp={onChangeOriginalParams}></textarea>
                        </div>
                        <div className={"col-12 mt-3 " + (editType===1 ? '':'d-none')}>
                            <span className="d-block fw-bold">Link Slug</span>
                            <div className="input-group">
                                <span className="input-group-text" id="basic-addon3">{shortio?.domain}/</span>
                                <textarea className="form-control" id="newSlug" ref={refNewSlug} onKeyUp={onChangeSlug} maxLength={256} rows={3}></textarea>
                            </div>
                            <p className={"mb-0 mt-1 text-end " + (charLen < 256 ? "text-success":"text-danger")}>{charLen}/256</p>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={props.handleModalClose}>
                        ปิด
                    </Button>
                    <Button variant="primary" onClick={onUpdateShortIO} disabled={isLoading}>
                        {isLoading ? 'กำลังอัพเดต..':'อัพเดต'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
} 